$(document).ready(() => {

    let $modal = $('#credit-card-modal');

    $modal
        .on('show.bs.modal', () => {
            $.get($modal.data('url'), (res) => {
                $modal.find('.step-content').html(res.html);
                let title = $modal.find('.step-content form').data('title');
                $modal.find('.title').text(title);
            });
        })
        .on('submit', 'form', (evt) => {

            evt.preventDefault();

            let $form = $(evt.target);
            let editDataSuccess = (res) => {
                $('#existing-cc').html(res.html);
                $modal.modal('toggle');
            };
            let editDataError = (res) => $modal.find('.step-content').html(res.responseJSON.html);

            ajaxSubmitForm($form, editDataSuccess, editDataError);

        });

    $('body').on('click', '.delete-card', function() {
        $.ajax({
        url: '/profile/delete-credit-card',
        type: 'post',
        data: {source: $(this).data('source')},
        dataType: 'json',
        statusCode: {
            200: (res) => $('#existing-cc').html(res.html),
            400: (res) => $('#existing-cc').html(res.responseJSON.html),
         },
        })
    });

});
